import React, { Component } from 'react'
import { connect } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar';
import { bindActionCreators } from 'redux'
import { showEditNoteModal, editNotes } from '../../../actions/profile';
import { inspectPortalAccount } from '../../../../../api'
import Icon from '@material-ui/core/Icon'
import Modal from "../../../../../components/modal";
import { DayPicker } from 'react-day-picker'
import styled from 'styled-components'
import { hostDateToString } from '../../inspect/util'
const moment = require('moment')

const TextBox = styled.textarea`
  background: #f1f2f5;
  border: none;
  border-radius: 4px;
  outline: none;
  color: #5a5a5a;
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  font-weight: 300;
  margin-bottom: 16px;
  max-width: 300px;
  min-height: 330px;
  padding: 12px;
  transition: 0.2s ease border, 0.2s ease box-shadow;
  width: 100%;
`;

const Container = styled.div`
  h2 {
    font-size: 1.25rem;
  }
`;


class EditNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      note: null,
      created_at: null,
      reportDate: '',
      noteId: '',
      isSubmitting: false,
      response: '',
      showSnackbar: false,
      changingDate: false,
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   if(!_.isEmpty(this.props.account.user.trainerNotes)) {
  //     const note = this.props.account.user.trainerNotes[nextProps.selectedNoteIndex]
  //     this.setState({
  //       note: note.note,
  //       reportDate: note.created_at,
  //       noteId: note.id,
  //       isSubmitting: false
  //     })
  //   }
  // }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  handleChangeDate = () => {
    this.setState({changingDate: true})
  }

  handleStopChangingDate = () => {
    this.setState({changingDate: false})
  }

  handleDayClick = ( day, { selected } ) => {
    this.setState({ changingDate: false, created_at: moment(day).local().format('YYYY-MM-DD') });
  }

  handleClose = () => {
    this.setState({changingDate: false, note: null, created_at: null})
    this.props.showEditNoteModal(false, this.props.selectedNoteIndex)
  }


  handleRequestClose = () => {
      this.setState({ showSnackbar: false });
  }

  handleSubmit = (e) => {
    this.setState({ isSubmitting: true })
    const selectedNote = this.props.account.user.trainerNotes[this.props.selectedNoteIndex]
    const effectiveNote = this.state.note === null ? selectedNote.note : this.state.note
    const effectiveCreatedAt = this.state.created_at === null ? hostDateToString(selectedNote.created_at) : this.state.created_at
    const mods = {
      created_at: effectiveCreatedAt,
      note: effectiveNote
    }
    this.props.editNotes(this.props.user.id, selectedNote.id, this.props.account.user.id, mods)
      .then(() => {
        this.setState({ showSnackbar: true, response: 'Note edited successfully!' })
        this.props.setUpdateNotes(true)
        this.handleClose()
      //   this.props.inspectPortalAccount(this.props.userId, this.props.account.user.id)
      }).catch((err) => {
        this.setState({ showSnackbar: true, response: err })
      });
  }

  render() {
    let effectiveNote = ''
    let effectiveCreatedAt = ''
    let reportDate = ''
    if (this.props.account.user.trainerNotes) {
      const selectedNote = this.props.account.user.trainerNotes[this.props.selectedNoteIndex]
      if (selectedNote) {
        if ('created_at' in selectedNote) {
          effectiveCreatedAt = this.state.created_at === null ? hostDateToString(selectedNote.created_at) : this.state.created_at
          effectiveNote = this.state.note === null ? selectedNote.note : this.state.note
          reportDate = moment(effectiveCreatedAt).calendar(null, {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'ddd MMM DD YYYY',
            lastDay: '[Yesterday]',
            lastWeek: 'ddd MMM DD YYYY',
            sameElse: 'ddd MMM DD YYYY'
          })
        }
      }
    }

    const { datePickerWrapper, profileThumb } = styles

    return (
      <Modal
        title="Edit Note"
        open={this.props.showModal}
        onClose={this.handleClose}
        submitLabel="Save"
        handleSubmit={this.handleSubmit}
      >
        <div style={{marginBottom: '8px', alignSelf: 'flex-start'}}>
          <div className='table-head-wrapper'>
            {!!this.props.account.user.profilePic && (
              <div style={{...profileThumb, backgroundImage: `url(${this.props.account.user.profilePic})`}}></div>
            )}
            <div><span style={{fontWeight: 'bold'}}>{this.props.account.user.full_name}</span><br />{this.props.account.user.email_address}</div>
          </div>
          <div style={{margin: '6px 0'}}>
            Select date: <span style={{fontSize: '1.17em', cursor: 'pointer', borderRadius: '10px', background: '#f8f8f8', display: 'inline-block', marginLeft: '20px', padding: '10px 15px'}} onClick={this.handleChangeDate}>{reportDate} &nbsp; &nbsp; <Icon style={{verticalAlign: 'text-bottom'}}>expand_more</Icon></span>
          </div>
        </div>
        <div className='edit-note-container'>
          {this.state.changingDate &&
            <Container>
              <div style={datePickerWrapper}>
                <DayPicker
                  selected={new Date(effectiveCreatedAt + ' 00:00:00')}
                  defaultMonth={new Date(effectiveCreatedAt + ' 00:00:00')}
                  modifiersStyles={{selected: {backgroundColor: '#1fc44a'}}}
                  onDayClick={this.handleDayClick}
                />
              </div>
            </Container>
          }
          <TextBox
            name='note'
            value={effectiveNote}
            onChange={this.handleChange}
          />
        </div>
        <Snackbar className='snackbar' open={this.state.showSnackbar} message={this.state.response} autoHideDuration={2000} onClose={this.handleRequestClose}/>
      </Modal>
    )
  }
}


const styles = {
    deleteButton: {
      background: '#ed4384',
      borderRadius: '3px',
      color: 'white',
      margin: '0 5px'
    },
    profileThumb: {
      background: 'white',
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      borderRadius: '50px',
      height: '80px',
      width: '80px',
      marginRight: '12px'
    },
    button: {
      yes: {
        background: '#eb0029',
        borderRadius: '3px',
        color: 'white',
        marginRight: 10,
        padding: '2px 15px',
      },
      no: {
        background: '#ddd',
        borderRadius: '3px',
        marginRight: 10,
        padding: '2px 15px',
      }
    },
    datePickerWrapper: {
      position: 'absolute',
      zIndex: '1',
      background: 'white',
      borderRadius: '5px',
      left: '50px'
    }
  }

function mapStateToProps(state) {
  return {
    selectedNoteIndex: state.user.selectedNoteIndex,
    showModal: state.user.showEditNoteModal,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showEditNoteModal, editNotes, inspectPortalAccount }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditNotes)
